/**
 * Returns `url` only if it is a safe, same-origin internal path.
 *
 * Whitelist: must start with `/` AND must NOT start with `//`.
 * Anything else — any URL scheme (http:, javascript:, data:, vbscript:, etc.),
 * protocol-relative `//host`, empty, or missing — returns null.
 *
 * Whitelist (not blacklist) is intentional: `javascript:`, `data:`, `vbscript:`
 * and future schemes all execute when assigned to `window.location.href`. A
 * blacklist would leave unknown schemes as XSS vectors if this value is ever
 * attacker-controlled (e.g., via a `?redirect=` search param in an email).
 */
export function validateInternalUrl(url: string | undefined | null): string | null {
  if (!url) return null;
  if (!url.startsWith('/')) return null;
  if (url.startsWith('//')) return null;
  return url;
}
